/*
 * ErfassungsPosition.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-05 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { VerfuegbarRender } from '@hudora/hd-react-components';
import { ValueRender } from '@hudora/react-jsonschema-valuerender';
import gql from 'graphql-tag';
import React from 'react';
import { useQuery } from 'urql';

import { ITEM_FRAGMENT, PREIS_FRAGMENT } from '../../fragments';
import { HdSpinner } from '../../lib/components/widgets/HdSpinner';

export function ErfassungsPosition({ pos }) {
  const [result] = useQuery({ query: VERFUEGBARKEITS_PREIS_QUERY, variables: { nr: pos.artnr } });
  const { fetching: loading, data } = result;

  return (
    <tr>
      <td>{pos.menge}</td>
      <td>{pos.artnr}</td>
      <td>{loading ? <HdSpinner /> : data?.h3Item?.name}</td>
      <td>
        <ValueRender value={data?.h3Item?.preis?.fh} format="eurocent" />
      </td>
      <td>{pos.preis ? <ValueRender value={pos.preis} format="eurocent" /> : null}</td>
      <td>
        <ValueRender value={(pos.preis || data?.h3Item?.preis?.fh) * pos.menge} format="eurocent" />
      </td>
      <td>
        <VerfuegbarRender itemNr={pos.artnr} />
      </td>
    </tr>
  );
}

const VERFUEGBARKEITS_PREIS_QUERY = gql`
  query itemPreiseLesen($nr: ID!) {
    h3Item(designator: $nr) {
      ...itemFragment
      preis: preisResolved {
        ...preisLFragment
      }
      zukunft {
        buchbestand
        frei_ab
        frei_max
        freie_menge
        naechster_zulauf
        zukuenftiger_zulauf
      }
    }
  }
  ${ITEM_FRAGMENT}
  ${PREIS_FRAGMENT}
`;
